export const startNewChat = "@/center/@startNewChat";
export const startNewChatSuccess = "@/center/@startNewChatSuccess";
export const startNewChatFailure = "@/center/@startNewChatFailure";
export const gettingAllChats = "@/center/@gettingAllChats";
export const getAllChatsSuccess = "@/center/@getAllChatsSuccess";
export const getAllChatsFailure = "@/center/@getAllChatsFailure";
